<!-- 全部课程 -->
<template>
<div class="container">
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="课程来源">
                    <el-select v-model="queryParams.ly" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in lyList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="适用年级">
                    <el-select v-model="queryParams.grade" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="审核状态">
                    <el-select v-model="queryParams.state" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in stateList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="coverUrl" label="课程封面" align="center">
						<template slot-scope="scope">
							<img :src="scope.row.coverUrl" style="height:42px" alt="">
                        </template>
                    </el-table-column>
                    <el-table-column prop="cname" label="课程名" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建/引入时间" align="center">
                    </el-table-column>
                    <el-table-column prop="typeName" label="课程类型" align="center">
                    </el-table-column>
					<el-table-column prop="source" label="课程来源" align="center">
                    </el-table-column>
                    <el-table-column prop="scope" label="适用年级" align="center">
						<template slot-scope="scope">
							<p>{{getGrade(scope.row.scope)}}</p>
						</template>
                    </el-table-column>
   
					<el-table-column prop="periodTotal" label="总课时" align="center">
                    </el-table-column>
                    <el-table-column prop="frequency" label="上课频率" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.frequency}}次/周</p>
						</template>
                    </el-table-column>
					<el-table-column prop="auditState" label="审核状态" align="center">
						<template slot-scope="scope">
							<p>{{stateObj[scope.row.auditState]}}</p>
						</template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
</div>
</template>
<script>
import schoolApi from '@/api/schoolApi/index.js'
import {getDetail} from '@/api/mechanismApi/curriculum.js'
import util from '@/utils/util.js'
import educationApi from '@/api/education/index.js'
export default {
    components:{
        Detail: ()=>import('./detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				ly: '',
				grade:'',
				date:'',
				state:'',
			},
			gradeList:JSON.parse(sessionStorage.getItem('gradeList')) || [],
			lyList: [],
			stateList:[
				{id:'0',label:'未送审'},
				{id:'1',label:'审核中'},
				{id:'2',label:'审核通过'},
				{id:'3',label:'审核失败'},
			],
			stateObj: {
				'0':'未送审',
				'1':'审核中',
				'2':'审核通过',
				'3':'审核失败',
			},
			tableData: [],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')),
		}
	},
	watch:{

	},
	created() {
		this.getDataList();
	},
	methods: {
		init(){
			this.queryParams = {
				grade:'',
				date:'',
				state:'',
			};
			this.pageNum=1;
			this.getDataList();
		},
		getGrade(scope){
			if(!scope) return '';
			return util.getGrade(scope)
		},
		async getDataList() {
			let params = {
				orgId:this.queryParams.ly,
				grade: this.queryParams.grade,
				auditState: this.queryParams.state,
				pageNum:this.pageNum,
				pageSize:this.pageSize,
			}
			let res = await schoolApi.getSchoolCourseALLList(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			let params = {
				id: item.cid,
			};
			let paramsData= {
			cid: item.cid,
			orgId:sessionStorage.getItem("orgId"),
			};
			var { result,data } = await getDetail(params);
			let res= await educationApi.getEducationCourseauditrecord(paramsData);
			if (result == "000000") {
				this.detail.info = data;
				if(res.result==='000000'){
					console.log('审批信息',res)
					if (res.data.length != 0) {
						this.detail.info.operateList=res.data || [];
					}else{
						this.detail.info.operateList=[{
							auditState: "",
							operateOpinion: "无审核记录",
							operateOrgName: "",
						}]
					}
				}
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
        toIndex(){
            this.detail.show=false;
        },
		
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.container{
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.index {
	width: 100%;
	height: 100%;
    padding: 0 30px 30px;
	overflow: auto;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 180px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
